(function ($) {
    $.ui = $.ui || {};
    $.ui.version = '1.12.1';
    var widgetUuid = 0,
        widgetSlice = Array.prototype.slice;
    ($.cleanData = (function (orig) {
        return function (elems) {
            var events, elem, i;
            for (i = 0; null != (elem = elems[i]); i++)
                try {
                    (events = $._data(elem, 'events')) && events.remove && $(elem).triggerHandler('remove');
                } catch (e) {}
            orig(elems);
        };
    })($.cleanData)),
        ($.widget = function (name, base, prototype) {
            var existingConstructor,
                constructor,
                basePrototype,
                proxiedPrototype = {},
                namespace = name.split('.')[0],
                fullName = namespace + '-' + (name = name.split('.')[1]);
            return (
                prototype || ((prototype = base), (base = $.Widget)),
                $.isArray(prototype) && (prototype = $.extend.apply(null, [{}].concat(prototype))),
                ($.expr[':'][fullName.toLowerCase()] = function (elem) {
                    return !!$.data(elem, fullName);
                }),
                ($[namespace] = $[namespace] || {}),
                (existingConstructor = $[namespace][name]),
                (constructor = $[namespace][name] =
                    function (options, element) {
                        if (!this._createWidget) return new constructor(options, element);
                        arguments.length && this._createWidget(options, element);
                    }),
                $.extend(constructor, existingConstructor, { version: prototype.version, _proto: $.extend({}, prototype), _childConstructors: [] }),
                (basePrototype = new base()),
                (basePrototype.options = $.widget.extend({}, basePrototype.options)),
                $.each(prototype, function (prop, value) {
                    $.isFunction(value)
                        ? (proxiedPrototype[prop] = (function () {
                              function _super() {
                                  return base.prototype[prop].apply(this, arguments);
                              }
                              function _superApply(args) {
                                  return base.prototype[prop].apply(this, args);
                              }
                              return function () {
                                  var returnValue,
                                      __super = this._super,
                                      __superApply = this._superApply;
                                  return (
                                      (this._super = _super),
                                      (this._superApply = _superApply),
                                      (returnValue = value.apply(this, arguments)),
                                      (this._super = __super),
                                      (this._superApply = __superApply),
                                      returnValue
                                  );
                              };
                          })())
                        : (proxiedPrototype[prop] = value);
                }),
                (constructor.prototype = $.widget.extend(
                    basePrototype,
                    { widgetEventPrefix: existingConstructor ? basePrototype.widgetEventPrefix || name : name },
                    proxiedPrototype,
                    { constructor: constructor, namespace: namespace, widgetName: name, widgetFullName: fullName }
                )),
                existingConstructor
                    ? ($.each(existingConstructor._childConstructors, function (i, child) {
                          var childPrototype = child.prototype;
                          $.widget(childPrototype.namespace + '.' + childPrototype.widgetName, constructor, child._proto);
                      }),
                      delete existingConstructor._childConstructors)
                    : base._childConstructors.push(constructor),
                $.widget.bridge(name, constructor),
                constructor
            );
        }),
        ($.widget.extend = function (target) {
            for (var key, value, input = widgetSlice.call(arguments, 1), inputIndex = 0, inputLength = input.length; inputIndex < inputLength; inputIndex++)
                for (key in input[inputIndex])
                    (value = input[inputIndex][key]),
                        input[inputIndex].hasOwnProperty(key) &&
                            void 0 !== value &&
                            ($.isPlainObject(value)
                                ? (target[key] = $.isPlainObject(target[key]) ? $.widget.extend({}, target[key], value) : $.widget.extend({}, value))
                                : (target[key] = value));
            return target;
        }),
        ($.widget.bridge = function (name, object) {
            var fullName = object.prototype.widgetFullName || name;
            $.fn[name] = function (options) {
                var isMethodCall = 'string' == typeof options,
                    args = widgetSlice.call(arguments, 1),
                    returnValue = this;
                return (
                    isMethodCall
                        ? this.length || 'instance' !== options
                            ? this.each(function () {
                                  var methodValue,
                                      instance = $.data(this, fullName);
                                  return 'instance' === options
                                      ? ((returnValue = instance), !1)
                                      : instance
                                      ? $.isFunction(instance[options]) && '_' !== options.charAt(0)
                                          ? (methodValue = instance[options].apply(instance, args)) !== instance && void 0 !== methodValue
                                              ? ((returnValue = methodValue && methodValue.jquery ? returnValue.pushStack(methodValue.get()) : methodValue), !1)
                                              : void 0
                                          : $.error("no such method '" + options + "' for " + name + ' widget instance')
                                      : $.error('cannot call methods on ' + name + " prior to initialization; attempted to call method '" + options + "'");
                              })
                            : (returnValue = void 0)
                        : (args.length && (options = $.widget.extend.apply(null, [options].concat(args))),
                          this.each(function () {
                              var instance = $.data(this, fullName);
                              instance ? (instance.option(options || {}), instance._init && instance._init()) : $.data(this, fullName, new object(options, this));
                          })),
                    returnValue
                );
            };
        }),
        ($.Widget = function () {}),
        ($.Widget._childConstructors = []),
        ($.Widget.prototype = {
            widgetName: 'widget',
            widgetEventPrefix: '',
            defaultElement: '<div>',
            options: { classes: {}, disabled: !1, create: null },
            _createWidget: function (options, element) {
                (element = $(element || this.defaultElement || this)[0]),
                    (this.element = $(element)),
                    (this.uuid = widgetUuid++),
                    (this.eventNamespace = '.' + this.widgetName + this.uuid),
                    (this.bindings = $()),
                    (this.hoverable = $()),
                    (this.focusable = $()),
                    (this.classesElementLookup = {}),
                    element !== this &&
                        ($.data(element, this.widgetFullName, this),
                        this._on(!0, this.element, {
                            remove: function (event) {
                                event.target === element && this.destroy();
                            },
                        }),
                        (this.document = $(element.style ? element.ownerDocument : element.document || element)),
                        (this.window = $(this.document[0].defaultView || this.document[0].parentWindow))),
                    (this.options = $.widget.extend({}, this.options, this._getCreateOptions(), options)),
                    this._create(),
                    this.options.disabled && this._setOptionDisabled(this.options.disabled),
                    this._trigger('create', null, this._getCreateEventData()),
                    this._init();
            },
            _getCreateOptions: function () {
                return {};
            },
            _getCreateEventData: $.noop,
            _create: $.noop,
            _init: $.noop,
            destroy: function () {
                var that = this;
                this._destroy(),
                    $.each(this.classesElementLookup, function (key, value) {
                        that._removeClass(value, key);
                    }),
                    this.element.off(this.eventNamespace).removeData(this.widgetFullName),
                    this.widget().off(this.eventNamespace).removeAttr('aria-disabled'),
                    this.bindings.off(this.eventNamespace);
            },
            _destroy: $.noop,
            widget: function () {
                return this.element;
            },
            option: function (key, value) {
                var parts,
                    curOption,
                    i,
                    options = key;
                if (0 === arguments.length) return $.widget.extend({}, this.options);
                if ('string' == typeof key)
                    if (((options = {}), (parts = key.split('.')), (key = parts.shift()), parts.length)) {
                        for (curOption = options[key] = $.widget.extend({}, this.options[key]), i = 0; i < parts.length - 1; i++)
                            (curOption[parts[i]] = curOption[parts[i]] || {}), (curOption = curOption[parts[i]]);
                        if (((key = parts.pop()), 1 === arguments.length)) return void 0 === curOption[key] ? null : curOption[key];
                        curOption[key] = value;
                    } else {
                        if (1 === arguments.length) return void 0 === this.options[key] ? null : this.options[key];
                        options[key] = value;
                    }
                return this._setOptions(options), this;
            },
            _setOptions: function (options) {
                var key;
                for (key in options) this._setOption(key, options[key]);
                return this;
            },
            _setOption: function (key, value) {
                return 'classes' === key && this._setOptionClasses(value), (this.options[key] = value), 'disabled' === key && this._setOptionDisabled(value), this;
            },
            _setOptionClasses: function (value) {
                var classKey, elements, currentElements;
                for (classKey in value)
                    (currentElements = this.classesElementLookup[classKey]),
                        value[classKey] !== this.options.classes[classKey] &&
                            currentElements &&
                            currentElements.length &&
                            ((elements = $(currentElements.get())),
                            this._removeClass(currentElements, classKey),
                            elements.addClass(this._classes({ element: elements, keys: classKey, classes: value, add: !0 })));
            },
            _setOptionDisabled: function (value) {
                this._toggleClass(this.widget(), this.widgetFullName + '-disabled', null, !!value),
                    value && (this._removeClass(this.hoverable, null, 'ui-state-hover'), this._removeClass(this.focusable, null, 'ui-state-focus'));
            },
            enable: function () {
                return this._setOptions({ disabled: !1 });
            },
            disable: function () {
                return this._setOptions({ disabled: !0 });
            },
            _classes: function (options) {
                function processClassString(classes, checkOption) {
                    var current, i;
                    for (i = 0; i < classes.length; i++)
                        (current = that.classesElementLookup[classes[i]] || $()),
                            (current = $(options.add ? $.unique(current.get().concat(options.element.get())) : current.not(options.element).get())),
                            (that.classesElementLookup[classes[i]] = current),
                            full.push(classes[i]),
                            checkOption && options.classes[classes[i]] && full.push(options.classes[classes[i]]);
                }
                var full = [],
                    that = this;
                return (
                    (options = $.extend({ element: this.element, classes: this.options.classes || {} }, options)),
                    this._on(options.element, { remove: '_untrackClassesElement' }),
                    options.keys && processClassString(options.keys.match(/\S+/g) || [], !0),
                    options.extra && processClassString(options.extra.match(/\S+/g) || []),
                    full.join(' ')
                );
            },
            _untrackClassesElement: function (event) {
                var that = this;
                $.each(that.classesElementLookup, function (key, value) {
                    -1 !== $.inArray(event.target, value) && (that.classesElementLookup[key] = $(value.not(event.target).get()));
                });
            },
            _removeClass: function (element, keys, extra) {
                return this._toggleClass(element, keys, extra, !1);
            },
            _addClass: function (element, keys, extra) {
                return this._toggleClass(element, keys, extra, !0);
            },
            _toggleClass: function (element, keys, extra, add) {
                add = 'boolean' == typeof add ? add : extra;
                var shift = 'string' == typeof element || null === element,
                    options = { extra: shift ? keys : extra, keys: shift ? element : keys, element: shift ? this.element : element, add: add };
                return options.element.toggleClass(this._classes(options), add), this;
            },
            _on: function (suppressDisabledCheck, element, handlers) {
                var delegateElement,
                    instance = this;
                'boolean' != typeof suppressDisabledCheck && ((handlers = element), (element = suppressDisabledCheck), (suppressDisabledCheck = !1)),
                    handlers
                        ? ((element = delegateElement = $(element)), (this.bindings = this.bindings.add(element)))
                        : ((handlers = element), (element = this.element), (delegateElement = this.widget())),
                    $.each(handlers, function (event, handler) {
                        function handlerProxy() {
                            if (suppressDisabledCheck || (!0 !== instance.options.disabled && !$(this).hasClass('ui-state-disabled')))
                                return ('string' == typeof handler ? instance[handler] : handler).apply(instance, arguments);
                        }
                        'string' != typeof handler && (handlerProxy.guid = handler.guid = handler.guid || handlerProxy.guid || $.guid++);
                        var match = event.match(/^([\w:-]*)\s*(.*)$/),
                            eventName = match[1] + instance.eventNamespace,
                            selector = match[2];
                        selector ? delegateElement.on(eventName, selector, handlerProxy) : element.on(eventName, handlerProxy);
                    });
            },
            _off: function (element, eventName) {
                (eventName = (eventName || '').split(' ').join(this.eventNamespace + ' ') + this.eventNamespace),
                    element.off(eventName).off(eventName),
                    (this.bindings = $(this.bindings.not(element).get())),
                    (this.focusable = $(this.focusable.not(element).get())),
                    (this.hoverable = $(this.hoverable.not(element).get()));
            },
            _delay: function (handler, delay) {
                var instance = this;
                return setTimeout(function () {
                    return ('string' == typeof handler ? instance[handler] : handler).apply(instance, arguments);
                }, delay || 0);
            },
            _hoverable: function (element) {
                (this.hoverable = this.hoverable.add(element)),
                    this._on(element, {
                        mouseenter: function (event) {
                            this._addClass($(event.currentTarget), null, 'ui-state-hover');
                        },
                        mouseleave: function (event) {
                            this._removeClass($(event.currentTarget), null, 'ui-state-hover');
                        },
                    });
            },
            _focusable: function (element) {
                (this.focusable = this.focusable.add(element)),
                    this._on(element, {
                        focusin: function (event) {
                            this._addClass($(event.currentTarget), null, 'ui-state-focus');
                        },
                        focusout: function (event) {
                            this._removeClass($(event.currentTarget), null, 'ui-state-focus');
                        },
                    });
            },
            _trigger: function (type, event, data) {
                var prop,
                    orig,
                    callback = this.options[type];
                if (
                    ((data = data || {}),
                    (event = $.Event(event)),
                    (event.type = (type === this.widgetEventPrefix ? type : this.widgetEventPrefix + type).toLowerCase()),
                    (event.target = this.element[0]),
                    (orig = event.originalEvent))
                )
                    for (prop in orig) prop in event || (event[prop] = orig[prop]);
                return this.element.trigger(event, data), !(($.isFunction(callback) && !1 === callback.apply(this.element[0], [event].concat(data))) || event.isDefaultPrevented());
            },
        }),
        $.each({ show: 'fadeIn', hide: 'fadeOut' }, function (method, defaultEffect) {
            $.Widget.prototype['_' + method] = function (element, options, callback) {
                'string' == typeof options && (options = { effect: options });
                var hasOptions,
                    effectName = options ? (!0 === options || 'number' == typeof options ? defaultEffect : options.effect || defaultEffect) : method;
                'number' == typeof (options = options || {}) && (options = { duration: options }),
                    (hasOptions = !$.isEmptyObject(options)),
                    (options.complete = callback),
                    options.delay && element.delay(options.delay),
                    hasOptions && $.effects && $.effects.effect[effectName]
                        ? element[method](options)
                        : effectName !== method && element[effectName]
                        ? element[effectName](options.duration, options.easing, callback)
                        : element.queue(function (next) {
                              $(this)[method](), callback && callback.call(element[0]), next();
                          });
            };
        });
    $.widget;
    !(function () {
        function getOffsets(offsets, width, height) {
            return [parseFloat(offsets[0]) * (rpercent.test(offsets[0]) ? width / 100 : 1), parseFloat(offsets[1]) * (rpercent.test(offsets[1]) ? height / 100 : 1)];
        }
        function parseCss(element, property) {
            return parseInt($.css(element, property), 10) || 0;
        }
        function getDimensions(elem) {
            var raw = elem[0];
            return 9 === raw.nodeType
                ? { width: elem.width(), height: elem.height(), offset: { top: 0, left: 0 } }
                : $.isWindow(raw)
                ? { width: elem.width(), height: elem.height(), offset: { top: elem.scrollTop(), left: elem.scrollLeft() } }
                : raw.preventDefault
                ? { width: 0, height: 0, offset: { top: raw.pageY, left: raw.pageX } }
                : { width: elem.outerWidth(), height: elem.outerHeight(), offset: elem.offset() };
        }
        var cachedScrollbarWidth,
            max = Math.max,
            abs = Math.abs,
            rhorizontal = /left|center|right/,
            rvertical = /top|center|bottom/,
            roffset = /[\+\-]\d+(\.[\d]+)?%?/,
            rposition = /^\w+/,
            rpercent = /%$/,
            _position = $.fn.position;
        ($.position = {
            scrollbarWidth: function () {
                if (void 0 !== cachedScrollbarWidth) return cachedScrollbarWidth;
                var w1,
                    w2,
                    div = $("<div style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>"),
                    innerDiv = div.children()[0];
                return (
                    $('body').append(div),
                    (w1 = innerDiv.offsetWidth),
                    div.css('overflow', 'scroll'),
                    (w2 = innerDiv.offsetWidth),
                    w1 === w2 && (w2 = div[0].clientWidth),
                    div.remove(),
                    (cachedScrollbarWidth = w1 - w2)
                );
            },
            getScrollInfo: function (within) {
                var overflowX = within.isWindow || within.isDocument ? '' : within.element.css('overflow-x'),
                    overflowY = within.isWindow || within.isDocument ? '' : within.element.css('overflow-y'),
                    hasOverflowX = 'scroll' === overflowX || ('auto' === overflowX && within.width < within.element[0].scrollWidth);
                return {
                    width: 'scroll' === overflowY || ('auto' === overflowY && within.height < within.element[0].scrollHeight) ? $.position.scrollbarWidth() : 0,
                    height: hasOverflowX ? $.position.scrollbarWidth() : 0,
                };
            },
            getWithinInfo: function (element) {
                var withinElement = $(element || window),
                    isWindow = $.isWindow(withinElement[0]),
                    isDocument = !!withinElement[0] && 9 === withinElement[0].nodeType;
                return {
                    element: withinElement,
                    isWindow: isWindow,
                    isDocument: isDocument,
                    offset: !isWindow && !isDocument ? $(element).offset() : { left: 0, top: 0 },
                    scrollLeft: withinElement.scrollLeft(),
                    scrollTop: withinElement.scrollTop(),
                    width: withinElement.outerWidth(),
                    height: withinElement.outerHeight(),
                };
            },
        }),
            ($.fn.position = function (options) {
                if (!options || !options.of) return _position.apply(this, arguments);
                options = $.extend({}, options);
                var atOffset,
                    targetWidth,
                    targetHeight,
                    targetOffset,
                    basePosition,
                    dimensions,
                    target = $(options.of),
                    within = $.position.getWithinInfo(options.within),
                    scrollInfo = $.position.getScrollInfo(within),
                    collision = (options.collision || 'flip').split(' '),
                    offsets = {};
                return (
                    (dimensions = getDimensions(target)),
                    target[0].preventDefault && (options.at = 'left top'),
                    (targetWidth = dimensions.width),
                    (targetHeight = dimensions.height),
                    (targetOffset = dimensions.offset),
                    (basePosition = $.extend({}, targetOffset)),
                    $.each(['my', 'at'], function () {
                        var horizontalOffset,
                            verticalOffset,
                            pos = (options[this] || '').split(' ');
                        1 === pos.length && (pos = rhorizontal.test(pos[0]) ? pos.concat(['center']) : rvertical.test(pos[0]) ? ['center'].concat(pos) : ['center', 'center']),
                            (pos[0] = rhorizontal.test(pos[0]) ? pos[0] : 'center'),
                            (pos[1] = rvertical.test(pos[1]) ? pos[1] : 'center'),
                            (horizontalOffset = roffset.exec(pos[0])),
                            (verticalOffset = roffset.exec(pos[1])),
                            (offsets[this] = [horizontalOffset ? horizontalOffset[0] : 0, verticalOffset ? verticalOffset[0] : 0]),
                            (options[this] = [rposition.exec(pos[0])[0], rposition.exec(pos[1])[0]]);
                    }),
                    1 === collision.length && (collision[1] = collision[0]),
                    'right' === options.at[0] ? (basePosition.left += targetWidth) : 'center' === options.at[0] && (basePosition.left += targetWidth / 2),
                    'bottom' === options.at[1] ? (basePosition.top += targetHeight) : 'center' === options.at[1] && (basePosition.top += targetHeight / 2),
                    (atOffset = getOffsets(offsets.at, targetWidth, targetHeight)),
                    (basePosition.left += atOffset[0]),
                    (basePosition.top += atOffset[1]),
                    this.each(function () {
                        var collisionPosition,
                            using,
                            elem = $(this),
                            elemWidth = elem.outerWidth(),
                            elemHeight = elem.outerHeight(),
                            marginLeft = parseCss(this, 'marginLeft'),
                            marginTop = parseCss(this, 'marginTop'),
                            collisionWidth = elemWidth + marginLeft + parseCss(this, 'marginRight') + scrollInfo.width,
                            collisionHeight = elemHeight + marginTop + parseCss(this, 'marginBottom') + scrollInfo.height,
                            position = $.extend({}, basePosition),
                            myOffset = getOffsets(offsets.my, elem.outerWidth(), elem.outerHeight());
                        'right' === options.my[0] ? (position.left -= elemWidth) : 'center' === options.my[0] && (position.left -= elemWidth / 2),
                            'bottom' === options.my[1] ? (position.top -= elemHeight) : 'center' === options.my[1] && (position.top -= elemHeight / 2),
                            (position.left += myOffset[0]),
                            (position.top += myOffset[1]),
                            (collisionPosition = { marginLeft: marginLeft, marginTop: marginTop }),
                            $.each(['left', 'top'], function (i, dir) {
                                $.ui.position[collision[i]] &&
                                    $.ui.position[collision[i]][dir](position, {
                                        targetWidth: targetWidth,
                                        targetHeight: targetHeight,
                                        elemWidth: elemWidth,
                                        elemHeight: elemHeight,
                                        collisionPosition: collisionPosition,
                                        collisionWidth: collisionWidth,
                                        collisionHeight: collisionHeight,
                                        offset: [atOffset[0] + myOffset[0], atOffset[1] + myOffset[1]],
                                        my: options.my,
                                        at: options.at,
                                        within: within,
                                        elem: elem,
                                    });
                            }),
                            options.using &&
                                (using = function (props) {
                                    var left = targetOffset.left - position.left,
                                        right = left + targetWidth - elemWidth,
                                        top = targetOffset.top - position.top,
                                        bottom = top + targetHeight - elemHeight,
                                        feedback = {
                                            target: { element: target, left: targetOffset.left, top: targetOffset.top, width: targetWidth, height: targetHeight },
                                            element: { element: elem, left: position.left, top: position.top, width: elemWidth, height: elemHeight },
                                            horizontal: right < 0 ? 'left' : left > 0 ? 'right' : 'center',
                                            vertical: bottom < 0 ? 'top' : top > 0 ? 'bottom' : 'middle',
                                        };
                                    targetWidth < elemWidth && abs(left + right) < targetWidth && (feedback.horizontal = 'center'),
                                        targetHeight < elemHeight && abs(top + bottom) < targetHeight && (feedback.vertical = 'middle'),
                                        max(abs(left), abs(right)) > max(abs(top), abs(bottom)) ? (feedback.important = 'horizontal') : (feedback.important = 'vertical'),
                                        options.using.call(this, props, feedback);
                                }),
                            elem.offset($.extend(position, { using: using }));
                    })
                );
            }),
            ($.ui.position = {
                fit: {
                    left: function (position, data) {
                        var newOverRight,
                            within = data.within,
                            withinOffset = within.isWindow ? within.scrollLeft : within.offset.left,
                            outerWidth = within.width,
                            collisionPosLeft = position.left - data.collisionPosition.marginLeft,
                            overLeft = withinOffset - collisionPosLeft,
                            overRight = collisionPosLeft + data.collisionWidth - outerWidth - withinOffset;
                        data.collisionWidth > outerWidth
                            ? overLeft > 0 && overRight <= 0
                                ? ((newOverRight = position.left + overLeft + data.collisionWidth - outerWidth - withinOffset), (position.left += overLeft - newOverRight))
                                : (position.left =
                                      overRight > 0 && overLeft <= 0 ? withinOffset : overLeft > overRight ? withinOffset + outerWidth - data.collisionWidth : withinOffset)
                            : overLeft > 0
                            ? (position.left += overLeft)
                            : overRight > 0
                            ? (position.left -= overRight)
                            : (position.left = max(position.left - collisionPosLeft, position.left));
                    },
                    top: function (position, data) {
                        var newOverBottom,
                            within = data.within,
                            withinOffset = within.isWindow ? within.scrollTop : within.offset.top,
                            outerHeight = data.within.height,
                            collisionPosTop = position.top - data.collisionPosition.marginTop,
                            overTop = withinOffset - collisionPosTop,
                            overBottom = collisionPosTop + data.collisionHeight - outerHeight - withinOffset;
                        data.collisionHeight > outerHeight
                            ? overTop > 0 && overBottom <= 0
                                ? ((newOverBottom = position.top + overTop + data.collisionHeight - outerHeight - withinOffset), (position.top += overTop - newOverBottom))
                                : (position.top =
                                      overBottom > 0 && overTop <= 0 ? withinOffset : overTop > overBottom ? withinOffset + outerHeight - data.collisionHeight : withinOffset)
                            : overTop > 0
                            ? (position.top += overTop)
                            : overBottom > 0
                            ? (position.top -= overBottom)
                            : (position.top = max(position.top - collisionPosTop, position.top));
                    },
                },
                flip: {
                    left: function (position, data) {
                        var newOverRight,
                            newOverLeft,
                            within = data.within,
                            withinOffset = within.offset.left + within.scrollLeft,
                            outerWidth = within.width,
                            offsetLeft = within.isWindow ? within.scrollLeft : within.offset.left,
                            collisionPosLeft = position.left - data.collisionPosition.marginLeft,
                            overLeft = collisionPosLeft - offsetLeft,
                            overRight = collisionPosLeft + data.collisionWidth - outerWidth - offsetLeft,
                            myOffset = 'left' === data.my[0] ? -data.elemWidth : 'right' === data.my[0] ? data.elemWidth : 0,
                            atOffset = 'left' === data.at[0] ? data.targetWidth : 'right' === data.at[0] ? -data.targetWidth : 0,
                            offset = -2 * data.offset[0];
                        overLeft < 0
                            ? ((newOverRight = position.left + myOffset + atOffset + offset + data.collisionWidth - outerWidth - withinOffset) < 0 ||
                                  newOverRight < abs(overLeft)) &&
                              (position.left += myOffset + atOffset + offset)
                            : overRight > 0 &&
                              ((newOverLeft = position.left - data.collisionPosition.marginLeft + myOffset + atOffset + offset - offsetLeft) > 0 || abs(newOverLeft) < overRight) &&
                              (position.left += myOffset + atOffset + offset);
                    },
                    top: function (position, data) {
                        var newOverTop,
                            newOverBottom,
                            within = data.within,
                            withinOffset = within.offset.top + within.scrollTop,
                            outerHeight = within.height,
                            offsetTop = within.isWindow ? within.scrollTop : within.offset.top,
                            collisionPosTop = position.top - data.collisionPosition.marginTop,
                            overTop = collisionPosTop - offsetTop,
                            overBottom = collisionPosTop + data.collisionHeight - outerHeight - offsetTop,
                            myOffset = 'top' === data.my[1] ? -data.elemHeight : 'bottom' === data.my[1] ? data.elemHeight : 0,
                            atOffset = 'top' === data.at[1] ? data.targetHeight : 'bottom' === data.at[1] ? -data.targetHeight : 0,
                            offset = -2 * data.offset[1];
                        overTop < 0
                            ? ((newOverBottom = position.top + myOffset + atOffset + offset + data.collisionHeight - outerHeight - withinOffset) < 0 ||
                                  newOverBottom < abs(overTop)) &&
                              (position.top += myOffset + atOffset + offset)
                            : overBottom > 0 &&
                              ((newOverTop = position.top - data.collisionPosition.marginTop + myOffset + atOffset + offset - offsetTop) > 0 || abs(newOverTop) < overBottom) &&
                              (position.top += myOffset + atOffset + offset);
                    },
                },
                flipfit: {
                    left: function () {
                        $.ui.position.flip.left.apply(this, arguments), $.ui.position.fit.left.apply(this, arguments);
                    },
                    top: function () {
                        $.ui.position.flip.top.apply(this, arguments), $.ui.position.fit.top.apply(this, arguments);
                    },
                },
            });
    })();
    $.ui.position,
        ($.ui.keyCode = {
            BACKSPACE: 8,
            COMMA: 188,
            DELETE: 46,
            DOWN: 40,
            END: 35,
            ENTER: 13,
            ESCAPE: 27,
            HOME: 36,
            LEFT: 37,
            PAGE_DOWN: 34,
            PAGE_UP: 33,
            PERIOD: 190,
            RIGHT: 39,
            SPACE: 32,
            TAB: 9,
            UP: 38,
        }),
        $.fn.extend({
            uniqueId: (function () {
                var uuid = 0;
                return function () {
                    return this.each(function () {
                        this.id || (this.id = 'ui-id-' + ++uuid);
                    });
                };
            })(),
            removeUniqueId: function () {
                return this.each(function () {
                    /^ui-id-\d+$/.test(this.id) && $(this).removeAttr('id');
                });
            },
        }),
        ($.ui.safeActiveElement = function (document) {
            var activeElement;
            try {
                activeElement = document.activeElement;
            } catch (error) {
                activeElement = document.body;
            }
            return activeElement || (activeElement = document.body), activeElement.nodeName || (activeElement = document.body), activeElement;
        }),
        $.widget('ui.menu', {
            version: '1.12.1',
            defaultElement: '<ul>',
            delay: 300,
            options: {
                icons: { submenu: 'ui-icon-caret-1-e' },
                items: '> *',
                menus: 'ul',
                position: { my: 'left top', at: 'right top' },
                role: 'menu',
                blur: null,
                focus: null,
                select: null,
            },
            _create: function () {
                (this.activeMenu = this.element),
                    (this.mouseHandled = !1),
                    this.element.uniqueId().attr({ role: this.options.role, tabIndex: 0 }),
                    this._addClass('ui-menu', 'ui-widget ui-widget-content'),
                    this._on({
                        'mousedown .ui-menu-item': function (event) {
                            event.preventDefault();
                        },
                        'click .ui-menu-item': function (event) {
                            var target = $(event.target),
                                active = $($.ui.safeActiveElement(this.document[0]));
                            !this.mouseHandled &&
                                target.not('.ui-state-disabled').length &&
                                (this.select(event),
                                event.isPropagationStopped() || (this.mouseHandled = !0),
                                target.has('.ui-menu').length
                                    ? this.expand(event)
                                    : !this.element.is(':focus') &&
                                      active.closest('.ui-menu').length &&
                                      (this.element.trigger('focus', [!0]), this.active && 1 === this.active.parents('.ui-menu').length && clearTimeout(this.timer)));
                        },
                        'mouseenter .ui-menu-item': function (event) {
                            if (!this.previousFilter) {
                                var actualTarget = $(event.target).closest('.ui-menu-item'),
                                    target = $(event.currentTarget);
                                actualTarget[0] === target[0] &&
                                    (this._removeClass(target.siblings().children('.ui-state-active'), null, 'ui-state-active'), this.focus(event, target));
                            }
                        },
                        mouseleave: 'collapseAll',
                        'mouseleave .ui-menu': 'collapseAll',
                        focus: function (event, keepActiveItem) {
                            var item = this.active || this.element.find(this.options.items).eq(0);
                            keepActiveItem || this.focus(event, item);
                        },
                        blur: function (event) {
                            this._delay(function () {
                                !$.contains(this.element[0], $.ui.safeActiveElement(this.document[0])) && this.collapseAll(event);
                            });
                        },
                        keydown: '_keydown',
                    }),
                    this.refresh(),
                    this._on(this.document, {
                        click: function (event) {
                            this._closeOnDocumentClick(event) && this.collapseAll(event), (this.mouseHandled = !1);
                        },
                    });
            },
            _destroy: function () {
                var submenus = this.element
                    .find('.ui-menu-item')
                    .removeAttr('role aria-disabled')
                    .children('.ui-menu-item-wrapper')
                    .removeUniqueId()
                    .removeAttr('tabIndex role aria-haspopup');
                this.element
                    .removeAttr('aria-activedescendant')
                    .find('.ui-menu')
                    .addBack()
                    .removeAttr('role aria-labelledby aria-expanded aria-hidden aria-disabled tabIndex')
                    .removeUniqueId()
                    .show(),
                    submenus.children().each(function () {
                        var elem = $(this);
                        elem.data('ui-menu-submenu-caret') && elem.remove();
                    });
            },
            _keydown: function (event) {
                var match,
                    prev,
                    character,
                    skip,
                    preventDefault = !0;
                switch (event.keyCode) {
                    case $.ui.keyCode.PAGE_UP:
                        this.previousPage(event);
                        break;
                    case $.ui.keyCode.PAGE_DOWN:
                        this.nextPage(event);
                        break;
                    case $.ui.keyCode.HOME:
                        this._move('first', 'first', event);
                        break;
                    case $.ui.keyCode.END:
                        this._move('last', 'last', event);
                        break;
                    case $.ui.keyCode.UP:
                        this.previous(event);
                        break;
                    case $.ui.keyCode.DOWN:
                        this.next(event);
                        break;
                    case $.ui.keyCode.LEFT:
                        this.collapse(event);
                        break;
                    case $.ui.keyCode.RIGHT:
                        this.active && !this.active.is('.ui-state-disabled') && this.expand(event);
                        break;
                    case $.ui.keyCode.ENTER:
                    case $.ui.keyCode.SPACE:
                        this._activate(event);
                        break;
                    case $.ui.keyCode.ESCAPE:
                        this.collapse(event);
                        break;
                    default:
                        (preventDefault = !1),
                            (prev = this.previousFilter || ''),
                            (skip = !1),
                            (character = event.keyCode >= 96 && event.keyCode <= 105 ? (event.keyCode - 96).toString() : String.fromCharCode(event.keyCode)),
                            clearTimeout(this.filterTimer),
                            character === prev ? (skip = !0) : (character = prev + character),
                            (match = this._filterMenuItems(character)),
                            (match = skip && -1 !== match.index(this.active.next()) ? this.active.nextAll('.ui-menu-item') : match).length ||
                                ((character = String.fromCharCode(event.keyCode)), (match = this._filterMenuItems(character))),
                            match.length
                                ? (this.focus(event, match),
                                  (this.previousFilter = character),
                                  (this.filterTimer = this._delay(function () {
                                      delete this.previousFilter;
                                  }, 1e3)))
                                : delete this.previousFilter;
                }
                preventDefault && event.preventDefault();
            },
            _activate: function (event) {
                this.active && !this.active.is('.ui-state-disabled') && (this.active.children("[aria-haspopup='true']").length ? this.expand(event) : this.select(event));
            },
            refresh: function () {
                var items,
                    newSubmenus,
                    newItems,
                    newWrappers,
                    that = this,
                    icon = this.options.icons.submenu,
                    submenus = this.element.find(this.options.menus);
                this._toggleClass('ui-menu-icons', null, !!this.element.find('.ui-icon').length),
                    (newSubmenus = submenus
                        .filter(':not(.ui-menu)')
                        .hide()
                        .attr({ role: this.options.role, 'aria-hidden': 'true', 'aria-expanded': 'false' })
                        .each(function () {
                            var menu = $(this),
                                item = menu.prev(),
                                submenuCaret = $('<span>').data('ui-menu-submenu-caret', !0);
                            that._addClass(submenuCaret, 'ui-menu-icon', 'ui-icon ' + icon),
                                item.attr('aria-haspopup', 'true').prepend(submenuCaret),
                                menu.attr('aria-labelledby', item.attr('id'));
                        })),
                    this._addClass(newSubmenus, 'ui-menu', 'ui-widget ui-widget-content ui-front'),
                    (items = submenus.add(this.element).find(this.options.items)).not('.ui-menu-item').each(function () {
                        var item = $(this);
                        that._isDivider(item) && that._addClass(item, 'ui-menu-divider', 'ui-widget-content');
                    }),
                    (newWrappers = (newItems = items.not('.ui-menu-item, .ui-menu-divider')).children().not('.ui-menu').uniqueId().attr({ tabIndex: -1, role: this._itemRole() })),
                    this._addClass(newItems, 'ui-menu-item')._addClass(newWrappers, 'ui-menu-item-wrapper'),
                    items.filter('.ui-state-disabled').attr('aria-disabled', 'true'),
                    this.active && !$.contains(this.element[0], this.active[0]) && this.blur();
            },
            _itemRole: function () {
                return { menu: 'menuitem', listbox: 'option' }[this.options.role];
            },
            _setOption: function (key, value) {
                if ('icons' === key) {
                    var icons = this.element.find('.ui-menu-icon');
                    this._removeClass(icons, null, this.options.icons.submenu)._addClass(icons, null, value.submenu);
                }
                this._super(key, value);
            },
            _setOptionDisabled: function (value) {
                this._super(value), this.element.attr('aria-disabled', String(value)), this._toggleClass(null, 'ui-state-disabled', !!value);
            },
            focus: function (event, item) {
                var nested, focused, activeParent;
                this.blur(event, event && 'focus' === event.type),
                    this._scrollIntoView(item),
                    (this.active = item.first()),
                    (focused = this.active.children('.ui-menu-item-wrapper')),
                    this._addClass(focused, null, 'ui-state-active'),
                    this.options.role && this.element.attr('aria-activedescendant', focused.attr('id')),
                    (activeParent = this.active.parent().closest('.ui-menu-item').children('.ui-menu-item-wrapper')),
                    this._addClass(activeParent, null, 'ui-state-active'),
                    event && 'keydown' === event.type
                        ? this._close()
                        : (this.timer = this._delay(function () {
                              this._close();
                          }, this.delay)),
                    (nested = item.children('.ui-menu')).length && event && /^mouse/.test(event.type) && this._startOpening(nested),
                    (this.activeMenu = item.parent()),
                    this._trigger('focus', event, { item: item });
            },
            _scrollIntoView: function (item) {
                var borderTop, paddingTop, offset, scroll, elementHeight, itemHeight;
                this._hasScroll() &&
                    ((borderTop = parseFloat($.css(this.activeMenu[0], 'borderTopWidth')) || 0),
                    (paddingTop = parseFloat($.css(this.activeMenu[0], 'paddingTop')) || 0),
                    (offset = item.offset().top - this.activeMenu.offset().top - borderTop - paddingTop),
                    (scroll = this.activeMenu.scrollTop()),
                    (elementHeight = this.activeMenu.height()),
                    (itemHeight = item.outerHeight()),
                    offset < 0
                        ? this.activeMenu.scrollTop(scroll + offset)
                        : offset + itemHeight > elementHeight && this.activeMenu.scrollTop(scroll + offset - elementHeight + itemHeight));
            },
            blur: function (event, fromFocus) {
                fromFocus || clearTimeout(this.timer),
                    this.active &&
                        (this._removeClass(this.active.children('.ui-menu-item-wrapper'), null, 'ui-state-active'),
                        this._trigger('blur', event, { item: this.active }),
                        (this.active = null));
            },
            _startOpening: function (submenu) {
                clearTimeout(this.timer),
                    'true' === submenu.attr('aria-hidden') &&
                        (this.timer = this._delay(function () {
                            this._close(), this._open(submenu);
                        }, this.delay));
            },
            _open: function (submenu) {
                var position = $.extend({ of: this.active }, this.options.position);
                clearTimeout(this.timer),
                    this.element.find('.ui-menu').not(submenu.parents('.ui-menu')).hide().attr('aria-hidden', 'true'),
                    submenu.show().removeAttr('aria-hidden').attr('aria-expanded', 'true').position(position);
            },
            collapseAll: function (event, all) {
                clearTimeout(this.timer),
                    (this.timer = this._delay(function () {
                        var currentMenu = all ? this.element : $(event && event.target).closest(this.element.find('.ui-menu'));
                        currentMenu.length || (currentMenu = this.element),
                            this._close(currentMenu),
                            this.blur(event),
                            this._removeClass(currentMenu.find('.ui-state-active'), null, 'ui-state-active'),
                            (this.activeMenu = currentMenu);
                    }, this.delay));
            },
            _close: function (startMenu) {
                startMenu || (startMenu = this.active ? this.active.parent() : this.element),
                    startMenu.find('.ui-menu').hide().attr('aria-hidden', 'true').attr('aria-expanded', 'false');
            },
            _closeOnDocumentClick: function (event) {
                return !$(event.target).closest('.ui-menu').length;
            },
            _isDivider: function (item) {
                return !/[^\-\u2014\u2013\s]/.test(item.text());
            },
            collapse: function (event) {
                var newItem = this.active && this.active.parent().closest('.ui-menu-item', this.element);
                newItem && newItem.length && (this._close(), this.focus(event, newItem));
            },
            expand: function (event) {
                var newItem = this.active && this.active.children('.ui-menu ').find(this.options.items).first();
                newItem &&
                    newItem.length &&
                    (this._open(newItem.parent()),
                    this._delay(function () {
                        this.focus(event, newItem);
                    }));
            },
            next: function (event) {
                this._move('next', 'first', event);
            },
            previous: function (event) {
                this._move('prev', 'last', event);
            },
            isFirstItem: function () {
                return this.active && !this.active.prevAll('.ui-menu-item').length;
            },
            isLastItem: function () {
                return this.active && !this.active.nextAll('.ui-menu-item').length;
            },
            _move: function (direction, filter, event) {
                var next;
                this.active &&
                    (next =
                        'first' === direction || 'last' === direction
                            ? this.active['first' === direction ? 'prevAll' : 'nextAll']('.ui-menu-item').eq(-1)
                            : this.active[direction + 'All']('.ui-menu-item').eq(0)),
                    (next && next.length && this.active) || (next = this.activeMenu.find(this.options.items)[filter]()),
                    this.focus(event, next);
            },
            nextPage: function (event) {
                var item, base, height;
                this.active
                    ? this.isLastItem() ||
                      (this._hasScroll()
                          ? ((base = this.active.offset().top),
                            (height = this.element.height()),
                            this.active.nextAll('.ui-menu-item').each(function () {
                                return (item = $(this)).offset().top - base - height < 0;
                            }),
                            this.focus(event, item))
                          : this.focus(event, this.activeMenu.find(this.options.items)[this.active ? 'last' : 'first']()))
                    : this.next(event);
            },
            previousPage: function (event) {
                var item, base, height;
                this.active
                    ? this.isFirstItem() ||
                      (this._hasScroll()
                          ? ((base = this.active.offset().top),
                            (height = this.element.height()),
                            this.active.prevAll('.ui-menu-item').each(function () {
                                return (item = $(this)).offset().top - base + height > 0;
                            }),
                            this.focus(event, item))
                          : this.focus(event, this.activeMenu.find(this.options.items).first()))
                    : this.next(event);
            },
            _hasScroll: function () {
                return this.element.outerHeight() < this.element.prop('scrollHeight');
            },
            select: function (event) {
                this.active = this.active || $(event.target).closest('.ui-menu-item');
                var ui = { item: this.active };
                this.active.has('.ui-menu').length || this.collapseAll(event, !0), this._trigger('select', event, ui);
            },
            _filterMenuItems: function (character) {
                var escapedCharacter = character.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&'),
                    regex = new RegExp('^' + escapedCharacter, 'i');
                return this.activeMenu
                    .find(this.options.items)
                    .filter('.ui-menu-item')
                    .filter(function () {
                        return regex.test($.trim($(this).children('.ui-menu-item-wrapper').text()));
                    });
            },
        });
    $.widget('ui.autocomplete', {
        version: '1.12.1',
        defaultElement: '<input>',
        options: {
            appendTo: null,
            autoFocus: !1,
            delay: 300,
            minLength: 1,
            position: { my: 'left top', at: 'left bottom', collision: 'none' },
            source: null,
            change: null,
            close: null,
            focus: null,
            open: null,
            response: null,
            search: null,
            select: null,
        },
        requestIndex: 0,
        pending: 0,
        _create: function () {
            var suppressKeyPress,
                suppressKeyPressRepeat,
                suppressInput,
                nodeName = this.element[0].nodeName.toLowerCase(),
                isTextarea = 'textarea' === nodeName,
                isInput = 'input' === nodeName;
            (this.isMultiLine = isTextarea || (!isInput && this._isContentEditable(this.element))),
                (this.valueMethod = this.element[isTextarea || isInput ? 'val' : 'text']),
                (this.isNewMenu = !0),
                this._addClass('ui-autocomplete-input'),
                this.element.attr('autocomplete', 'off'),
                this._on(this.element, {
                    keydown: function (event) {
                        if (this.element.prop('readOnly')) return (suppressKeyPress = !0), (suppressInput = !0), void (suppressKeyPressRepeat = !0);
                        (suppressKeyPress = !1), (suppressInput = !1), (suppressKeyPressRepeat = !1);
                        var keyCode = $.ui.keyCode;
                        switch (event.keyCode) {
                            case keyCode.PAGE_UP:
                                (suppressKeyPress = !0), this._move('previousPage', event);
                                break;
                            case keyCode.PAGE_DOWN:
                                (suppressKeyPress = !0), this._move('nextPage', event);
                                break;
                            case keyCode.UP:
                                (suppressKeyPress = !0), this._keyEvent('previous', event);
                                break;
                            case keyCode.DOWN:
                                (suppressKeyPress = !0), this._keyEvent('next', event);
                                break;
                            case keyCode.ENTER:
                                this.menu.active && ((suppressKeyPress = !0), event.preventDefault(), this.menu.select(event));
                                break;
                            case keyCode.TAB:
                                this.menu.active && this.menu.select(event);
                                break;
                            case keyCode.ESCAPE:
                                this.menu.element.is(':visible') && (this.isMultiLine || this._value(this.term), this.close(event), event.preventDefault());
                                break;
                            default:
                                (suppressKeyPressRepeat = !0), this._searchTimeout(event);
                        }
                    },
                    keypress: function (event) {
                        if (suppressKeyPress) return (suppressKeyPress = !1), void ((this.isMultiLine && !this.menu.element.is(':visible')) || event.preventDefault());
                        if (!suppressKeyPressRepeat) {
                            var keyCode = $.ui.keyCode;
                            switch (event.keyCode) {
                                case keyCode.PAGE_UP:
                                    this._move('previousPage', event);
                                    break;
                                case keyCode.PAGE_DOWN:
                                    this._move('nextPage', event);
                                    break;
                                case keyCode.UP:
                                    this._keyEvent('previous', event);
                                    break;
                                case keyCode.DOWN:
                                    this._keyEvent('next', event);
                            }
                        }
                    },
                    input: function (event) {
                        if (suppressInput) return (suppressInput = !1), void event.preventDefault();
                        this._searchTimeout(event);
                    },
                    focus: function () {
                        (this.selectedItem = null), (this.previous = this._value());
                    },
                    blur: function (event) {
                        this.cancelBlur ? delete this.cancelBlur : (clearTimeout(this.searching), this.close(event), this._change(event));
                    },
                }),
                this._initSource(),
                (this.menu = $('<ul>').appendTo(this._appendTo()).menu({ role: null }).hide().menu('instance')),
                this._addClass(this.menu.element, 'ui-autocomplete', 'ui-front'),
                this._on(this.menu.element, {
                    mousedown: function (event) {
                        event.preventDefault(),
                            (this.cancelBlur = !0),
                            this._delay(function () {
                                delete this.cancelBlur, this.element[0] !== $.ui.safeActiveElement(this.document[0]) && this.element.trigger('focus');
                            });
                    },
                    menufocus: function (event, ui) {
                        var label, item;
                        if (this.isNewMenu && ((this.isNewMenu = !1), event.originalEvent && /^mouse/.test(event.originalEvent.type)))
                            return (
                                this.menu.blur(),
                                void this.document.one('mousemove', function () {
                                    $(event.target).trigger(event.originalEvent);
                                })
                            );
                        (item = ui.item.data('ui-autocomplete-item')),
                            !1 !== this._trigger('focus', event, { item: item }) && event.originalEvent && /^key/.test(event.originalEvent.type) && this._value(item.value),
                            (label = ui.item.attr('aria-label') || item.value) &&
                                $.trim(label).length &&
                                (this.liveRegion.children().hide(), $('<div>').text(label).appendTo(this.liveRegion));
                    },
                    menuselect: function (event, ui) {
                        var item = ui.item.data('ui-autocomplete-item'),
                            previous = this.previous;
                        this.element[0] !== $.ui.safeActiveElement(this.document[0]) &&
                            (this.element.trigger('focus'),
                            (this.previous = previous),
                            this._delay(function () {
                                (this.previous = previous), (this.selectedItem = item);
                            })),
                            !1 !== this._trigger('select', event, { item: item }) && this._value(item.value),
                            (this.term = this._value()),
                            this.close(event),
                            (this.selectedItem = item);
                    },
                }),
                (this.liveRegion = $('<div>', { role: 'status', 'aria-live': 'assertive', 'aria-relevant': 'additions' }).appendTo(this.document[0].body)),
                this._addClass(this.liveRegion, null, 'ui-helper-hidden-accessible'),
                this._on(this.window, {
                    beforeunload: function () {
                        this.element.removeAttr('autocomplete');
                    },
                });
        },
        _destroy: function () {
            clearTimeout(this.searching), this.element.removeAttr('autocomplete'), this.menu.element.remove(), this.liveRegion.remove();
        },
        _setOption: function (key, value) {
            this._super(key, value),
                'source' === key && this._initSource(),
                'appendTo' === key && this.menu.element.appendTo(this._appendTo()),
                'disabled' === key && value && this.xhr && this.xhr.abort();
        },
        _isEventTargetInWidget: function (event) {
            var menuElement = this.menu.element[0];
            return event.target === this.element[0] || event.target === menuElement || $.contains(menuElement, event.target);
        },
        _closeOnClickOutside: function (event) {
            this._isEventTargetInWidget(event) || this.close();
        },
        _appendTo: function () {
            var element = this.options.appendTo;
            return (
                element && (element = element.jquery || element.nodeType ? $(element) : this.document.find(element).eq(0)),
                (element && element[0]) || (element = this.element.closest('.ui-front, dialog')),
                element.length || (element = this.document[0].body),
                element
            );
        },
        _initSource: function () {
            var array,
                url,
                that = this;
            $.isArray(this.options.source)
                ? ((array = this.options.source),
                  (this.source = function (request, response) {
                      response($.ui.autocomplete.filter(array, request.term));
                  }))
                : 'string' == typeof this.options.source
                ? ((url = this.options.source),
                  (this.source = function (request, response) {
                      that.xhr && that.xhr.abort(),
                          (that.xhr = $.ajax({
                              url: url,
                              data: request,
                              dataType: 'json',
                              success: function (data) {
                                  response(data);
                              },
                              error: function () {
                                  response([]);
                              },
                          }));
                  }))
                : (this.source = this.options.source);
        },
        _searchTimeout: function (event) {
            clearTimeout(this.searching),
                (this.searching = this._delay(function () {
                    var equalValues = this.term === this._value(),
                        menuVisible = this.menu.element.is(':visible'),
                        modifierKey = event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
                    (equalValues && (!equalValues || menuVisible || modifierKey)) || ((this.selectedItem = null), this.search(null, event));
                }, this.options.delay));
        },
        search: function (value, event) {
            return (
                (value = null != value ? value : this._value()),
                (this.term = this._value()),
                value.length < this.options.minLength ? this.close(event) : !1 !== this._trigger('search', event) ? this._search(value) : void 0
            );
        },
        _search: function (value) {
            this.pending++, this._addClass('ui-autocomplete-loading'), (this.cancelSearch = !1), this.source({ term: value }, this._response());
        },
        _response: function () {
            var index = ++this.requestIndex;
            return $.proxy(function (content) {
                index === this.requestIndex && this.__response(content), --this.pending || this._removeClass('ui-autocomplete-loading');
            }, this);
        },
        __response: function (content) {
            content && (content = this._normalize(content)),
                this._trigger('response', null, { content: content }),
                !this.options.disabled && content && content.length && !this.cancelSearch ? (this._suggest(content), this._trigger('open')) : this._close();
        },
        close: function (event) {
            (this.cancelSearch = !0), this._close(event);
        },
        _close: function (event) {
            this._off(this.document, 'mousedown'),
                this.menu.element.is(':visible') && (this.menu.element.hide(), this.menu.blur(), (this.isNewMenu = !0), this._trigger('close', event));
        },
        _change: function (event) {
            this.previous !== this._value() && this._trigger('change', event, { item: this.selectedItem });
        },
        _normalize: function (items) {
            return items.length && items[0].label && items[0].value
                ? items
                : $.map(items, function (item) {
                      return 'string' == typeof item ? { label: item, value: item } : $.extend({}, item, { label: item.label || item.value, value: item.value || item.label });
                  });
        },
        _suggest: function (items) {
            var ul = this.menu.element.empty();
            this._renderMenu(ul, items),
                (this.isNewMenu = !0),
                this.menu.refresh(),
                ul.show(),
                this._resizeMenu(),
                ul.position($.extend({ of: this.element }, this.options.position)),
                this.options.autoFocus && this.menu.next(),
                this._on(this.document, { mousedown: '_closeOnClickOutside' });
        },
        _resizeMenu: function () {
            var ul = this.menu.element;
            ul.outerWidth(Math.max(ul.width('').outerWidth() + 1, this.element.outerWidth()));
        },
        _renderMenu: function (ul, items) {
            var that = this;
            $.each(items, function (index, item) {
                that._renderItemData(ul, item);
            });
        },
        _renderItemData: function (ul, item) {
            return this._renderItem(ul, item).data('ui-autocomplete-item', item);
        },
        _renderItem: function (ul, item) {
            return $('<li>').append($('<div>').text(item.label)).appendTo(ul);
        },
        _move: function (direction, event) {
            if (this.menu.element.is(':visible'))
                return (this.menu.isFirstItem() && /^previous/.test(direction)) || (this.menu.isLastItem() && /^next/.test(direction))
                    ? (this.isMultiLine || this._value(this.term), void this.menu.blur())
                    : void this.menu[direction](event);
            this.search(null, event);
        },
        widget: function () {
            return this.menu.element;
        },
        _value: function () {
            return this.valueMethod.apply(this.element, arguments);
        },
        _keyEvent: function (keyEvent, event) {
            (this.isMultiLine && !this.menu.element.is(':visible')) || (this._move(keyEvent, event), event.preventDefault());
        },
        _isContentEditable: function (element) {
            if (!element.length) return !1;
            var editable = element.prop('contentEditable');
            return 'inherit' === editable ? this._isContentEditable(element.parent()) : 'true' === editable;
        },
    }),
        $.extend($.ui.autocomplete, {
            escapeRegex: function (value) {
                return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');
            },
            filter: function (array, term) {
                var matcher = new RegExp($.ui.autocomplete.escapeRegex(term), 'i');
                return $.grep(array, function (value) {
                    return matcher.test(value.label || value.value || value);
                });
            },
        }),
        $.widget('ui.autocomplete', $.ui.autocomplete, {
            options: {
                messages: {
                    noResults: 'No search results.',
                    results: function (amount) {
                        return amount + (amount > 1 ? ' results are' : ' result is') + ' available, use up and down arrow keys to navigate.';
                    },
                },
            },
            __response: function (content) {
                var message;
                this._superApply(arguments),
                    this.options.disabled ||
                        this.cancelSearch ||
                        ((message = content && content.length ? this.options.messages.results(content.length) : this.options.messages.noResults),
                        this.liveRegion.children().hide(),
                        $('<div>').text(message).appendTo(this.liveRegion));
            },
        });
    $.ui.autocomplete;
})(jQuery);

var dawaAddressProxyBaseUrl = 'https://api.webplatform-prod-01.topdanmark.cloud/c9-address-proxy/v1';

(function ($) {
    $.widget &&
        $.widget('dawa.dawaautocomplete', {
            options: {
                baseUrl: dawaAddressProxyBaseUrl,
                minLength: 2,
                delay: 0,
                adgangsadresserOnly: !1,
                autoFocus: !0,
                timeout: 1e4,
                error: null,
                params: {},
                fuzzy: !0,
                stormodtagerpostnumre: !0,
            },
            _create: function () {
                function get(params, cb) {
                    var stringifiedParams = JSON.stringify(params);
                    if (cache[stringifiedParams]) return cb(cache[stringifiedParams]);
                    $.ajax({
                        url: options.baseUrl + '/autocomplete-search',
                        method: 'POST',
                        contentType: 'application/json',
                        dataType: 'json',
                        headers: { 'x-top-appname': 'flos' },
                        data: JSON.stringify($.extend({}, params, options.params)),
                        timeout: options.timeout,
                        success: function (data) {
                            (cache[stringifiedParams] = data), cb(data);
                        },
                        error: options.error,
                    });
                }
                function getAddressDetails(id, cb) {
                    $.ajax({
                        url: options.baseUrl + '/addresses-search',
                        method: 'POST',
                        contentType: 'application/json',
                        dataType: 'json',
                        headers: { 'x-top-appname': 'flos' },
                        data: JSON.stringify({ id: id }),
                        timeout: options.timeout,
                        success: function (data) {
                            cb(data);
                        },
                        error: function (xhr, status, error) {
                            options.error && options.error(xhr, status, error), cb(null);
                        },
                    });
                }
                function stormodtagerAdresseTekst(data) {
                    var adresse = data.vejnavn;
                    return (
                        data.husnr && (adresse += ' ' + data.husnr),
                        (data.etage || data.dør) && (adresse += ','),
                        data.etage && (adresse += ' ' + data.etage + '.'),
                        data.dør && (adresse += ' ' + data.dør),
                        (adresse += ', '),
                        data.supplerendebynavn && (adresse += data.supplerendebynavn + ', '),
                        (adresse += data.stormodtagerpostnr + ' ' + data.stormodtagerpostnrnavn)
                    );
                }
                function getAutocompleteResponse(type, q, currentCaretPos, cb) {
                    var params = {
                        q: q,
                        type: type,
                        caretpos: currentCaretPos,
                        fuzzy: options.fuzzy ? 'true' : 'false',
                        stormodtagerpostnumre: options.stormodtagerpostnumre ? 'true' : 'false',
                    };
                    adgangsadresseid && (params.adgangsadresseid = adgangsadresseid), skipVejnavn && (params.startfra = 'adgangsadresse'), (skipVejnavn = !1);
                    var adgangsadresseRestricted = !!adgangsadresseid;
                    (adgangsadresseid = null),
                        get(params, function (result) {
                            var processedResult = result.reduce(function (memo, row) {
                                if (('adgangsadresse' !== row.type && 'adresse' !== row.type) || !row.data.stormodtagerpostnr) memo.push(row);
                                else {
                                    var stormodtagerEntry = jQuery.extend({}, row);
                                    (stormodtagerEntry.tekst = stormodtagerAdresseTekst(row.data)), (stormodtagerEntry.forslagstekst = stormodtagerEntry.tekst);
                                    var rows = [];
                                    q !== stormodtagerEntry.tekst && rows.push(row),
                                        q !== row.tekst && rows.push(stormodtagerEntry),
                                        rows.length > 1 && -1 !== q.indexOf(row.data.stormodtagerpostnr) && (rows = [rows[1], rows[0]]),
                                        (memo = memo.concat(rows));
                                }
                                return memo;
                            }, []);
                            adgangsadresseRestricted && 1 === processedResult.length
                                ? (element.val(processedResult[0].tekst),
                                  (element.selectionStart = caretpos = processedResult[0].caretpos),
                                  element.autocomplete('close'),
                                  autocompleteWidget._trigger('select', null, processedResult[0]))
                                : cb(processedResult);
                        });
                }
                var element = this.element,
                    options = this.options,
                    targetType = options.adgangsadresserOnly ? 'adgangsadresse' : 'adresse',
                    autocompleteWidget = this,
                    caretpos = null,
                    adgangsadresseid = null,
                    skipVejnavn = !1,
                    cache = {},
                    autocompleteOptions = $.extend({}, options, {
                        source: function (request, response) {
                            var q = request.term;
                            return (caretpos = element[0].selectionStart), getAutocompleteResponse(targetType, q, caretpos, response);
                        },
                        select: function (event, ui) {
                            event.preventDefault();
                            var item = ui.item;
                            element.val(item.tekst),
                                (element[0].selectionStart = element[0].selectionEnd = caretpos = item.caretpos),
                                item.type !== targetType
                                    ? ('adgangsadresse' === item.type && (adgangsadresseid = item.data.id),
                                      'vejnavn' === item.type && (skipVejnavn = !0),
                                      setTimeout(function () {
                                          element.autocomplete('search');
                                      }))
                                    : (element.autocomplete('close'),
                                      getAddressDetails(item.data.id, function (details) {
                                          autocompleteWidget._trigger(
                                              'select',
                                              null,
                                              $.extend({}, item, { addressDetails: details, kvhx: details && details[0] && details[0].kvhx })
                                          );
                                      }));
                        },
                    });
                (element.autocomplete(autocompleteOptions).data('ui-autocomplete')._renderItem = function (ul, item) {
                    return ul.addClass('tds-address-list'), $('<li></li>').addClass('tds-address-list-item').append(item.forslagstekst).appendTo(ul);
                }),
                    element.on('autocompletefocus', function (event) {
                        event.preventDefault();
                    }),
                    setInterval(function () {
                        var currentCaretpos = element[0].selectionStart;
                        element[0] === document.activeElement && caretpos !== currentCaretpos && ((caretpos = currentCaretpos), element.autocomplete('search'));
                    }, 100);
            },
        });
})(jQuery);

var waitForEl = function (selector, callback) {
    if ($(selector).length) {
        callback();
    } else {
        setTimeout(function () {
            waitForEl(selector, callback);
        }, 100);
    }
};

var initAddr1 = function () {
    var $addressLookup = $('.js-address-lookup'),
        $addressLookupField = $addressLookup.find('.js-address-lookup-input'),
        $addressLookupHidden = $addressLookup.find('input:hidden'),
        $addressLookupInput = $addressLookup.find('.js-adr-auto-complete ');
    $addressLookupField.dawaautocomplete({
        baseUrl: dawaAddressProxyBaseUrl,
        minLength: 2,
        delay: 0,
        adgangsadresserOnly: !1,
        params: {},
        timeout: 1e4,
        error: function (xhr, status, error) {},
    });
    $addressLookupField.on('dawaautocompleteselect', function (event, item) {
        var kvhx = item && item.kvhx;
        $addressLookupHidden.val(kvhx || '');
        $(this).add($addressLookupInput).attr('data-addr-lookup-complete', !!kvhx);
    });
    $addressLookupInput.on('blur', function (e) {
        let parent = $(this).parent();
        let iconError = parent.children('.flos-field-icon.is-error');
        let iconSuccess = parent.children('.flos-field-icon.has-success');
        if ($(e.target).attr('data-addr-lookup-complete') === 'true') {
            $(e.target).siblings('.help-block').text('');
            $(this).parent().removeClass('has-error').addClass('has-success');
            iconSuccess.removeClass('visuallyhidden');
            iconError.addClass('visuallyhidden');
        } else {
            // hack to override the validation done by Hippo
            setTimeout(() => {
                parent.removeClass('has-success').addClass('has-error');
                iconSuccess.addClass('visuallyhidden');
                iconError.removeClass('visuallyhidden');
            }, 300);
        }
        if ('' === $(this).val() || $(this).parent().hasClass('has-error')) {
            $addressLookupHidden.val('');
        }
    });
    $addressLookupInput.on('input', function (e) {
        $(e.target).attr('data-addr-lookup-complete', false);
    });
};

var initAddr2 = function () {
    let currentCaretpos = 0;
    let param = {
        type: 'adresse',
    };
    let advParam = {
        type: 'adresse',
        startfra: 'adgangsadresse',
    };
    let uid;
    let addrNextLevel = false;

    let address = $('.js-adr-auto-complete')
        .autocomplete({
            autoFocus: true,
            minLength: 2,
            source: function (request, response) {
                $.ajax({
                    url: dawaAddressProxyBaseUrl + '/autocomplete-search',
                    method: 'POST',
                    contentType: 'application/json',
                    dataType: 'json',
                    headers: { 'x-top-appname': 'flos' },
                    data: JSON.stringify(
                        $.extend({}, addrNextLevel ? advParam : param, {
                            fuzzy: 'true',
                            stormodtagerpostnumre: 'true',
                            q: request.term,
                            caretpos: request.term.length,
                        })
                    ),
                    success: function (result) {
                        response(result.map((data) => ({ label: data.forslagstekst, value: data.forslagstekst, type: data.type, id: data.data && data.data.id })));
                    },
                });
            },
            select: (event, ui) => {
                let label = ui.item.label;
                label.length > currentCaretpos || currentCaretpos == 0 ? (currentCaretpos = label.length) : (currentCaretpos = currentCaretpos);
                if (!addrNextLevel) {
                    setTimeout(() => {
                        uid.search(ui.item.label + ' ');
                    });
                }
                let isFinalSelection = ui.item.type === 'adresse' || ui.item.type === 'adgangsadresse';
                let $target = $(event.target);
                let $hiddenInput = $target.closest('.js-address-lookup').find('input:hidden');
                addrNextLevel = !addrNextLevel;

                if (isFinalSelection && ui.item.id) {
                    $target.attr('data-addr-lookup-complete', false);
                    $.ajax({
                        url: dawaAddressProxyBaseUrl + '/addresses-search',
                        method: 'POST',
                        contentType: 'application/json',
                        dataType: 'json',
                        headers: { 'x-top-appname': 'flos' },
                        data: JSON.stringify({ id: ui.item.id }),
                        success: function (details) {
                            let kvhx = details && details[0] && details[0].kvhx;
                            $hiddenInput.val(kvhx || '');
                            $target.attr('data-addr-lookup-complete', !!kvhx);
                        },
                        error: function () {
                            $hiddenInput.val('');
                            $target.attr('data-addr-lookup-complete', false);
                        },
                    });
                } else {
                    $hiddenInput.val('');
                    $target.attr('data-addr-lookup-complete', isFinalSelection);
                }
            },
        })
        .on('focus', function () {
            // the element with the search results
            uid = $(this).autocomplete('instance');
        });
};

waitForEl('.js-address-lookup', initAddr1);
waitForEl('.js-adr-auto-complete', initAddr2);
